/**
 * MWS Portal Services
 * REST Services der Portal-Anwendung MWS
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type Variation = 'ABSOLUTE' | 'PERCENTAGE';

export const Variation = {
    Absolute: 'ABSOLUTE' as Variation,
    Percentage: 'PERCENTAGE' as Variation
};

